import { userClient } from "@/api/userClient";
import { ListPersonalAttendancePreDayReq } from "@/pbjs/external/user/user_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
// lee 绩效接口参数
interface Options {
  dateRange: string; // 查询的开始时间
  name?: string; // 查询的结束时间
  userId?: number; // 查询某用户组的所有员工，如果这个字段有值，那优先过滤这个条件
  email?: string;
  employeeID?: string;
  userGroupIds?: Array<number>;
  pageIndex: number;
  pageSize: number;
}
export function listPersonalAttendanceDetail(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new ListPersonalAttendancePreDayReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDaterange(arg.dateRange);
      request.setEmployeeid(arg.employeeID);
      request.setUsergroupidsList(arg.userGroupIds);
      // request.setUserid(arg.userId);
      request.setUserid(null); // 预留字段
      request.setName(arg.name);
      request.setEmail(arg.email);
      // setRank
      let _res = await userClient.listPersonalAttendancePreDay(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function downloadPersonalAttendanceDetailExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new ListPersonalAttendancePreDayReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDaterange(arg.dateRange);
      request.setEmployeeid(arg.employeeID);
      request.setUsergroupidsList(arg.userGroupIds);
      request.setUserid(null); // 预留字段
      request.setName(arg.name);
      request.setEmail(arg.email);
      // setRank
      let _res = await userClient.downloadPersonalAttendancePreDayExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
